module.exports = __webpack_public_path__ + "images/emoji/tractor.b2ca413ed970bf5b9a3e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/tractor.png
// module id = EMvf
// module chunks = 1